import React from "react"
import CurvedLineGraph from "./CurvedLineGraph"

const Tollbooth = ({ data }) => (
  <CurvedLineGraph name={"toolpassing"} data={data} />
)

export default Tollbooth
